import React from 'react';
import './HandHistoryCard.css';

interface HandHistoryCardProps {
    rank: string;
    suit: string;
}

export const HandHistoryCard: React.FC<HandHistoryCardProps> = ({ rank, suit }) => {
    const isRed = suit === 'h' || suit === 'd';
    const suitSymbol = {
        'h': '♥',
        'd': '♦',
        'c': '♣',
        's': '♠'
    }[suit] || suit;
    
    return (
        <div className="history-card">
            <div className={`history-card__content ${isRed ? 'history-card__content--red' : 'history-card__content--black'}`}>
                <span className="history-card__rank">{rank}</span>
                <span className="history-card__suit">{suitSymbol}</span>
            </div>
        </div>
    );
}; 